// extracted by mini-css-extract-plugin
var _1 = "iqPA1lQcAG";
var _2 = "uKOXKkLL4Y";
var _3 = "yKCSMceT1y";
export { _1 as "fieldSet", _2 as "form", _3 as "legend" }
